import { LoginAction } from "@/services/DTOs/LoginAction";
import Cookies from "js-cookie";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { OpportunitiesApiService } from "./OpportunitiesApiService";

class Service {

  public login(
    action: LoginAction,
    context?: string | Array<string | undefined>,
    detailId?: string,
    referrerId?: string,
    referrerUsername?: string
  ): Promise<any> {
    const before = new Promise((resolve, reject) => {
      if (action != null) {
        OpportunitiesApiService.post(`/api/suite/store-action`, action)
          .subscribe(
            undefined,
            // tslint:disable-next-line:no-console
            (error) => console.log(error),
            resolve);
      } else {
        resolve();
      }
    });

    const redirectUrl = action.action === "redirect" ? action.args[0] : undefined;

    return before.then(() => {
      const queryParams = [
        { name: "context", value: context instanceof Array ? context[0] : context },
        { name: "intent",  value: context instanceof Array ? context[1] : context },
        { name: "next", value: redirectUrl },
        { name: "detail_id", value: detailId },
        { name: "referrer_id", value: referrerId },
        { name: "referrer_username", value: referrerUsername }
      ];
      const qs = "?" + queryParams.filter((param) => !!param.value).map((param) => `${param.name}=${param.value}`).join("&");

      window.location.href = `/login${qs}`;
    });
  }

  public firebaseLogin(): Observable<string> {
    const url = "/firebase-login";
    return OpportunitiesApiService.get(url).pipe(map((response) => {
      return response.data.token;
    }));
  }

  public logout(): void {
    if ((window as any).FS && typeof (window as any).FS.anonymize === "function") {
      (window as any).FS.anonymize();
    }
    window.location.href = "/logout";
  }

  public retrieveSessionState(): string {
    return Cookies.get("torre.session_state") || "";
  }

}

export const AuthService = new Service();
